import { stepSchema } from './SelectOrderDateV2.types';

export const CHANGE_ORDER_DATE_STEP = stepSchema.enum;

export const INITIAL_STEP = CHANGE_ORDER_DATE_STEP.select;
